import { useCallback, useEffect, useState } from "react";
import {
  loadSelectedArbitrumRunPresetIds,
  type ArbitrumRunPresetId,
} from "./run-presets";

export function useArbitrumPanelState() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [presetsOpen, setPresetsOpen] = useState(false);
  const [expandOpen, setExpandOpen] = useState(false);
  const [selectedPresetIds, setSelectedPresetIds] = useState<
    ArbitrumRunPresetId[]
  >(() => loadSelectedArbitrumRunPresetIds());

  const openPresets = useCallback(() => {
    setSettingsOpen(false);
    setExpandOpen(false);
    setPresetsOpen(true);
  }, []);

  const closePresets = useCallback(() => {
    setPresetsOpen(false);
  }, []);

  const toggleSettings = useCallback(() => {
    setPresetsOpen(false);
    setExpandOpen(false);
    setSettingsOpen((value) => !value);
  }, []);

  const openExpand = useCallback(() => {
    setPresetsOpen(false);
    setSettingsOpen(false);
    setExpandOpen(true);
  }, []);

  const closeExpand = useCallback(() => {
    setExpandOpen(false);
  }, []);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (
        event as CustomEvent<{ presetIds?: ArbitrumRunPresetId[] }>
      ).detail;
      setSelectedPresetIds(
        detail?.presetIds ?? loadSelectedArbitrumRunPresetIds(),
      );
    };
    window.addEventListener("fintheon:arbitrum-run-presets-changed", handler);
    return () =>
      window.removeEventListener(
        "fintheon:arbitrum-run-presets-changed",
        handler,
      );
  }, []);

  return {
    settingsOpen,
    presetsOpen,
    expandOpen,
    selectedPresetIds,
    setSettingsOpen,
    openPresets,
    closePresets,
    toggleSettings,
    openExpand,
    closeExpand,
  };
}
